import changePhasePopupComponent from './changePhasePopup.component';

const changePhasePopupModule = angular.module('app.components.changePhasePopup', [])
	.component('changePhasePopup', changePhasePopupComponent)
	.name;

export default changePhasePopupModule;
